import { Controller } from "@hotwired/stimulus";
import { selectize } from "../selectizeHelper";

export default class EditController extends Controller {
    static targets = [
        "labels"
    ];

    readonly labelsTarget!: HTMLElement;

    connect() {
        selectize($(this.labelsTarget), {
            plugins: ["remove_button"]
        });
    }
}
